import { CARD_IMAGES } from './cards.js'

const normalized = Object.fromEntries(
  Object.entries(CARD_IMAGES).map(([name, image]) => [name.replace(/ё/g, 'е').toLowerCase(), image]),
)

export function cardFace(raw) {
  const name = String(raw || '').replace(/\s*\((прямая|перевёрнутая)\)\s*$/i, '').trim()
  return CARD_IMAGES[name] || normalized[name.replace(/ё/g, 'е').toLowerCase()] || '/assets/tarot-card.webp'
}
